<mat-accordion>
  <mat-expansion-panel [(expanded)]="isExpanded">
    <mat-expansion-panel-header>
      <mat-panel-title>Investors</mat-panel-title>
    </mat-expansion-panel-header>
    <div class="col-md-12">
      <div class="row btn-row">
        @if (!editMode && permissions._edit) {
          <div class="col-md-2">
            <button mat-raised-button class="edit-button" (click)="toggleEdit()">EDIT</button>
          </div>
        }
        @if (editMode && permissions._edit) {
          <div class="col-md-2">
            <button mat-raised-button class="save-button" (click)="updateInvestor(forms)" style="margin-right:7px">SAVE</button>
            <button mat-raised-button class="edit-button" (click)="toggleEdit()">Cancel</button>
          </div>
        }
        <!--        <div class="col-md-11" *ngIf="!editMode && permissions._edit"><button mat-raised-button class="edit-button" (click)="toggleEdit()">EDIT</button></div>-->
        <!--        <div class="col-md-11" *ngIf="editMode && permissions._edit">-->
        <!--          <div class="row">-->
        <!--            <button mat-raised-button class="save-button" (click)="updateInvestor(forms)" style="max-width: 60px; margin-right: 3px">SAVE</button>-->
        <!--            <button mat-raised-button class="edit-button" (click)="toggleEdit()" style="max-width: 60px">Cancel</button>-->
      <!--          </div>-->
    <!--        </div>-->
    <!--        <div *ngIf="editMode && permissions._edit" style="flex-direction: column; max-width: 50px"><button mat-mini-fab class="add-button" (click)="updateInvestor(forms)" matTooltip="Save investor details"><i class="material-icons" style="font-size: 16px;">save</i></button></div>-->
    <div class="col-md-10">
      <div class="row justify-flex-end">
        @if (editMode && permissions._edit) {
          <div style="flex-direction: column; max-width: 50px">
            <button mat-mini-fab (click)="addInvestor()" class="add-button" matTooltip="Add Investor"><i class="material-icons">add</i></button>
          </div>
        }
      </div>
    </div>
  </div>

  @if (!editMode) {
    @for (investor of fundService.investors$ | async; track investor) {
      <div class="row">
        <div class="row" style="max-width: 30%">
          <div class="col-8"><h4><a href="{{getOrgLink(investor)}}" class="data-link" target="_blank">{{investor.investor}}</a></h4></div>
          <div class="col-4"><small style="font-weight: bold; color: lightslategray; opacity: 60%">{{investor.is_repeat ? 'REPEAT' : 'NEW'}}</small></div>
        </div>
        <div class="mat-elevation-z4">
          <table mat-table class="stripped-table" [dataSource]="getDataSource(investor.investments)">
            <ng-container matColumnDef="investor_class">
              <th mat-header-cell *matHeaderCellDef>Investment Class</th>
              <td mat-cell *matCellDef="let row">{{row.investor_class.name}}</td>
            </ng-container>
            <ng-container matColumnDef="amount">
              <th mat-header-cell *matHeaderCellDef>Amount</th>
              <td mat-cell *matCellDef="let row">{{row.amount | currency: 'USD': 'symbol': '1.2-2'}}</td>
            </ng-container>
            <ng-container matColumnDef="admission_date">
              <th mat-header-cell *matHeaderCellDef>Admission Date</th>
              <td mat-cell *matCellDef="let row">
                @if (row.admission_date!==null) {
                  {{row.admission_date | date: 'MM/dd/yyyy'}}
                }
                @if (row.admission_date==null) {
                  --
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="exit_date">
              <th mat-header-cell *matHeaderCellDef>Exit Date</th>
              <td mat-cell *matCellDef="let row">
                @if (row.exit_date!==null) {
                  {{row.exit_date | date: 'MM/dd/yyyy'}}
                }
                @if (row.exit_date==null) {
                  --
                }
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="investorColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: investorColumns"></tr>
          </table>
          @if (investor.comments!==null) {
            <div class="row comments-row">
              <span><strong style="font-size: 14px">Comments: </strong>{{investor.comments}}</span>
            </div>
          }
        </div>
      </div>
    }
  }
  @if (editMode) {
    @for (form of forms; track form) {
      <div class="row">
        <form [formGroup]="form">
          <div class="col">
            @if (form.value.id==null) {
              <mat-divider style="margin-top: 15px; margin-bottom: 15px;border-top-width: 2px;"></mat-divider>
            }
            <div class="row">
              @if (form.value.id!==null) {
                <div class="col-md-6">
                  <span style="display: flex; flex-direction: row">
                    <h4><a href="{{getOrgLink(form.value)}}" class="data-link" target="_blank">{{form.value.name}}</a></h4>
                    <button type="button" mat-mini-fab class="delete-button" (click)="deleteInvestor(form)" matTooltip="Remove investor from fund"><i class="material-icons" style="font-size: 16px;">delete</i></button>
                  </span>
                </div>
              }
              @if (form.value.id==null) {
                <div class="col-md-6">
                  <span style="display: flex; flex-direction: row; margin-top: 5px;">
                    <mat-form-field>
                      <mat-label>Investor</mat-label>
                      <input matInput name="name" type="text" [matAutocomplete]="searchauto" (focus)="searchInvestorOrgs(form)" [formControl]="form.controls.name">
                    </mat-form-field>
                    <mat-autocomplete #searchauto="matAutocomplete" [displayWith]="displayVal">
                      @for (val of searchInvestors; track val) {
                        <mat-option [value]="val">{{val.name}}</mat-option>
                      }
                    </mat-autocomplete>
                    <button type="button" mat-mini-fab class="delete-button" (click)="deleteInvestor(form)" matTooltip="Remove investor from fund"><i class="material-icons" style="font-size: 16px;">delete</i></button>
                  </span>
                </div>
              }
              <!--              <div class="col-md-5">-->
              <!--                <button mat-mini-fab class="delete-button" (click)="deleteInvestor(form)" matTooltip="Remove investor from fund"><i class="material-icons" style="font-size: 16px;">delete</i></button>-->
            <!--              </div>-->
            <div class="col-md-6">
              <mat-button-toggle-group formControlName="is_repeat">
                <mat-button-toggle [value]="false">NEW</mat-button-toggle>
                <mat-button-toggle [value]="true">REPEAT</mat-button-toggle>
              </mat-button-toggle-group>
            </div>
          </div>
          <!-- <mat-divider style="margin-top: 15px; margin-bottom: 15px;"></mat-divider> -->
          <!--            <div class="row">-->
          <!--              <mat-form-field>-->
          <!--                <mat-label>Comments</mat-label>-->
          <!--                <textarea matInput formControlName="comments" name="comments" type="text"></textarea>-->
        <!--              </mat-form-field>-->
      <!--            </div>-->
      <div class="row">
        <div class="col-md-10"><h4>Investments</h4></div>
        <div class="col-md-2">
          <div class="row justify-flex-end"><button type="button" mat-flat-button (click)="addInvestment(form)" class="add-investment"><i class="material-icons">add</i>Investment</button></div>
        </div>
        <ng-container formArrayName="investments">
          <div class="mat-elevation-z4">
            <table mat-table class="stripped-table" [dataSource]="getDataSource(form.controls.investments.controls)">
              <ng-container matColumnDef="investor_class">
                <th mat-header-cell *matHeaderCellDef>Investment Class</th>
                <td mat-cell *matCellDef="let row" [formGroup]="row">
                  <mat-form-field>
                    <mat-label>Investment Class</mat-label>
                    <input matInput name="name" type="text" [matAutocomplete]="typeauto" (focus)="searchInvestorType(row)" [formControl]="row.controls.investor_class">
                  </mat-form-field>
                  <mat-autocomplete #typeauto="matAutocomplete" [displayWith]="displayVal">
                    @for (val of searchTypes; track val) {
                      <mat-option [value]="val">{{val.name}}</mat-option>
                    }
                  </mat-autocomplete>
                  <!--                          <mat-form-field>-->
                  <!--                            <mat-select [formControl]="row.controls.investor_class" [placeholder]="row.controls.investor_class.value?.name ?? 'Investment Class'">-->
                  <!--                              <mat-option *ngFor="let cs of classes" [value]="cs">{{cs.name}}</mat-option>-->
                <!--                            </mat-select>-->
              <!--                          </mat-form-field>-->
            </td>
          </ng-container>
          <ng-container matColumnDef="amount">
            <th mat-header-cell *matHeaderCellDef>Amount</th>
            <td mat-cell *matCellDef="let row" [formGroup]="row">
              <mat-form-field>
                <mat-label>Amount</mat-label>
                <input matInput [formControl]="row.controls.amount" name="amount" type="number">
                <mat-hint>{{row.value.amount | currency: 'USD': 'symbol': '1.2-2'}}</mat-hint>
              </mat-form-field>
            </td>
          </ng-container>
          <ng-container matColumnDef="admission_date">
            <th mat-header-cell *matHeaderCellDef>Admission Date</th>
            <td mat-cell *matCellDef="let row" [formGroup]="row">
              <mat-form-field>
                <mat-label>Admission Date</mat-label>
                <input matInput type="text" [formControl]="row.controls.admission_date" [matDatepicker]="admissionDatePicker">
                <mat-datepicker-toggle matIconPrefix [for]="admissionDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #admissionDatePicker></mat-datepicker>
              </mat-form-field>
            </td>
          </ng-container>
          <ng-container matColumnDef="exit_date">
            <th mat-header-cell *matHeaderCellDef>Exit Date</th>
            <td mat-cell *matCellDef="let row" [formGroup]="row">
              <mat-form-field>
                <mat-label>Exit Date</mat-label>
                <input matInput type="text" [formControl]="row.controls.exit_date" name="closingDate" [matDatepicker]="exitDatePicker">
                <mat-datepicker-toggle matIconPrefix [for]="exitDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #exitDatePicker></mat-datepicker>
              </mat-form-field>
            </td>
          </ng-container>
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row">
              <!--                          <button mat-mini-fab class="action-button" (click)="updateInvestment(row)" *ngIf="form.value.id!==null"><i class="material-icons" style="font-size: 16px">save</i></button>-->
              <button type="button" mat-mini-fab class="action-button" (click)="deleteInvestment(row, form)"><i class="material-icons" style="font-size: 16px">delete</i></button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="editColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: editColumns"></tr>
        </table>
      </div>
    </ng-container>
  </div>
</div>
<div class="row" style="margin-top: 7px">
  <mat-form-field>
    <mat-label>Comments</mat-label>
    <textarea matInput formControlName="comments" name="comments" type="text"></textarea>
  </mat-form-field>
</div>
</form>
<mat-divider style="margin-top: 30px; margin-bottom: 30px; border-top-width: 2px;"></mat-divider>
</div>
}
}
</div>
</mat-expansion-panel>
</mat-accordion>
